import React from 'react';
import Button from '../UI/button';
import ThSearchForm from '../forms/th-search-form';
import SvgIcon from '../SVG/svg';

interface PublicTripsNavBarProps {
  onSortByStateChange: (state: boolean) => void;
  searchQuery: string;
  onSearchChange: (value: string) => void;
  onSearchSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
}

function PublicTripsNavBar({
  onSortByStateChange,
  searchQuery,
  onSearchChange,
  onSearchSubmit
}: PublicTripsNavBarProps) {
  const handleSortBy = () => {
    onSortByStateChange(true);
  };

  return (
    <div className='trips-toolbar public-trips-toolbar'>
      <div className='top-navbar-page public-trips-toolbar-layout'>
        {/* Search bar — row 1 on mobile */}
        <div className='trips-toolbar-search-row'>
          <ThSearchForm
            handleSubmit={onSearchSubmit}
            value={searchQuery}
            onChange={onSearchChange}
            placeholder='Search public trips...'
            fullWidth={true}
          />
        </div>

        {/* Title — hidden on mobile, centred on desktop */}
        <div className='trips-toolbar-title'>
          <h2 className='text-dark m-0'>Public Trips</h2>
        </div>

        {/* Row 2 on mobile — sort button left, spacer right */}
        <div className='trips-toolbar-actions-row'>
          <Button
            variant='transparent'
            width={50}
            height={50}
            onClick={handleSortBy}
          >
            <SvgIcon type='sort' />
          </Button>
        </div>
      </div>
    </div>
  );
}

export default PublicTripsNavBar;
